import b from "./_baseIsEqualDeep.js";
import f from "./isObjectLike.js";
var t = b, r = f;
function e(s, i, a, n, u) {
  return s === i ? !0 : s == null || i == null || !r(s) && !r(i) ? s !== s && i !== i : t(s, i, a, n, e, u);
}
var m = e;
export {
  m as default
};
//# sourceMappingURL=_baseIsEqual.js.map
